/**
 * Elimina un pedido (DELETE /list/:id).
 */
import axiosInstance from '../../api/axiosInstance'

export const ORDER_DELETE_SUCCESS_MESSAGE = 'Pedido eliminado Exitosamente!.'

function isDeleteSuccessMessage(message: string): boolean {
  const m = message.trim()
  return m === ORDER_DELETE_SUCCESS_MESSAGE || m.includes('Pedido eliminado Exitosamente')
}

export async function deleteOrderById(
  orderId: number
): Promise<{ ok: boolean; message?: string }> {
  const token = localStorage.getItem('accessToken')
  if (!token) {
    return { ok: false, message: 'No hay sesión' }
  }

  try {
    const response = await axiosInstance.delete(`/list/${orderId}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    const message = String(response.data?.message ?? '')
    if (isDeleteSuccessMessage(message)) {
      return { ok: true, message }
    }
    return { ok: false, message: message || 'La API no confirmó la eliminación del pedido' }
  } catch (error: unknown) {
    const msg =
      error && typeof error === 'object' && 'response' in error
        ? String(
            (error as { response?: { data?: { message?: string } } }).response?.data?.message || ''
          )
        : error && typeof error === 'object' && 'message' in error
          ? String((error as { message: string }).message)
          : 'Error al eliminar el pedido'
    return { ok: false, message: msg }
  }
}
